import React, { ReactNode } from 'react';
import { Button, Flex, Image, Spin } from 'antd';
import { FormikProps } from 'formik';

import { useAppDispatch, useAppSelector } from '../../../store';
import { generateImage, selectAIImageState } from '../store/aiImage.slice';

interface Props {
    formik: FormikProps<any>;
    children?: ReactNode;
    targetParamName: string;
    paramName?: string;
    mainButtonText?: string;
    isEdit?: boolean;
}

export const AiImageGenerator = ({
    targetParamName,
    paramName,
    children,
    formik,
    mainButtonText,
    isEdit,
}: Props) => {
    const dispatch = useAppDispatch();
    const { imageUrl: url, isLoading } = useAppSelector(selectAIImageState);

    const selectGeneratedImage = (photoSrc: string, isEdit: boolean) => {
        if (!isEdit) {
            const existing = formik.values[paramName] || [];
            const updated = Array.isArray(existing)
                ? [...existing, photoSrc]
                : [photoSrc];
            formik.setFieldValue('photo_url', updated);
        } else formik.setFieldValue('photo_url', photoSrc);
    };

    return (
        <>
            <Flex vertical={false}>
                {children}

                {isLoading ? (
                    <div
                        style={{
                            marginTop: '35px',
                            marginLeft: '15px',
                        }}
                    >
                        <Spin />
                    </div>
                ) : url ? (
                    <Flex vertical gap={12}>
                        <div
                            style={{
                                width: '100px',
                                height: '100px',
                            }}
                        >
                            <Image
                                style={{
                                    borderRadius: '0.5rem',
                                }}
                                key={url}
                                preview={false}
                                src={url}
                                alt={formik.values[targetParamName]}
                            />
                        </div>

                        <Flex vertical gap={8}>
                            <Button
                                block
                                onClick={() =>
                                    selectGeneratedImage(url, isEdit)
                                }
                            >
                                {mainButtonText
                                    ? mainButtonText
                                    : 'Выбрать главным фото'}
                            </Button>
                            <Button
                                block
                                onClick={() =>
                                    dispatch(
                                        generateImage(
                                            formik.values[targetParamName]
                                        )
                                    )
                                }
                            >
                                Сгенерировать ещё
                            </Button>
                        </Flex>
                    </Flex>
                ) : null}
            </Flex>
        </>
    );
};
